<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Third ID Region"
            @input="updateThirdIdFiltered()"
            prepend-icon="mdi-magnify"
            v-model="sub_id"
            :prefix="`13- ${this.sub_id == null ? '' : this.sub_id} - `"
            solo
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name</th>
              <th scope="col">ThirdIdRegion</th>
              <th scope="col">Begin</th>
              <th scope="col">End</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="region in regions" v-if="isRegionFiltered(region)">
              <td>{{ region.id }}</td>
              <td>{{ region.name }}</td>
              <td>{{ region.thirdIdRegion }}</td>
              <td>{{ region.begin }}</td>
              <td>{{ region.end }}</td>
              <td>
                <router-link
                  v-if="isAdminUser"
                  class="btn btn-edit"
                  v-bind:to="{ path: 'editRegion', query: { id: region.id } }"
                >
                  <v-icon>mdi-pencil</v-icon>
                  <span class="editspan">Edit</span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../parameters";
import { httpClient, authState } from "../../requesters/httpClient";
import { USER_ROLE } from "../../requesters/userConstants";

export default {
  name: "Regions",
  data() {
    return {
      regions: [],
      id: "13",
      sub_id: null,
      third_id_filtered: "13--",
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/regions`)
      .then((response) => {
        this.regions = response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    updateThirdIdFiltered: function () {
      this.sub_id = this.sub_id === null ? "" : this.sub_id;

      this.third_id_filtered = this.id + "-" + this.sub_id + "-" + this.sub_id;
    },
    isRegionFiltered: function (region) {
      return (
        this.third_id_filtered === "13--" ||
        this.third_id_filtered === region.thirdIdRegion
      );
    }
  },
};
</script>





// WEBPACK FOOTER //
// src/components/regions/Regions.vue